module.exports = __webpack_public_path__ + "img/es.7f8bdec.svg";